import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = 'https://amdqkozrlsmkqkrgboue.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImFtZHFrb3pybHNta3Frcmdib3VlIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODc0MzQ5MTMsImV4cCI6MjEwMzAxMDkxM30.Evj1u1zElAhaET8SAL4bGCF4iqweZCP3DwJbv42w9Nc'

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  throw new Error('Missing Supabase variables')
}

export default createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  }
})